import type { LayerProbe } from './types';

export async function readCachedProbe(layerId: string): Promise<LayerProbe | null> {
  const data = await window.api.layerCacheRead(layerId);
  return data as LayerProbe | null;
}

export async function writeCachedProbe(layerId: string, probe: LayerProbe): Promise<void> {
  await window.api.layerCacheWrite(layerId, probe);
}

export async function invalidateCachedProbe(layerId: string): Promise<boolean> {
  return window.api.layerCacheInvalidate(layerId);
}

export function isProbeStale(probe: LayerProbe): boolean {
  const last = probe.service.last_edit_date;
  if (typeof last !== 'number') return false;
  return last > probe.probed_at;
}
